import { createClient } from "@/utils/supabase/client";

export async function getMembership(userId: string) {
  const supabase = await createClient();
  const { data, error } = await supabase.from('profiles').select('membership').eq('user_id', userId);
  return data;
}